import Mock from './Mock';

export default class TokenServiceMock {
  static token() {
    return Mock.call({
      token: 'TestToken',
      refreshToken: 'TestRefreshToken',
    });
  }

  static refreshToken() {
    return Mock.call({
      token: 'TestToken',
      refreshToken: 'TestRefreshToken',
    });
  }
}
